import React from 'react';

const SHGCreateEditModal = ({ 
  isOpen, 
  onClose, 
  formData, 
  setFormData, 
  onSubmit, 
  isEditing,
  message,
  submitting
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/90 flex items-center justify-center z-[100] px-4 py-6 overflow-y-auto">
      <div className="bg-gray-900 border border-pink-500/50 rounded-3xl w-full my-auto max-h-[90vh] overflow-y-auto">
        <div className="bg-gray-900 border-b border-pink-800 px-4 py-2 flex items-center justify-between">
          <h2 className="text-lg lg:text-xl font-bold text-pink-100">
            {isEditing ? 'Edit Group' : 'Create New Group'}
          </h2>
          <button onClick={onClose} className="text-xs lg:text-sm w-fit px-2 py-1 text-gray-400 hover:text-white leading-none">✕</button>
        </div>

        <div className="px-4 py-1 space-y-2">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div>
              <label className="block text-pink-300 text-sm mb-2">Group Name <span className="text-red-400">*</span></label>
              <input type="text" value={formData.groupName} onChange={(e) => setFormData({...formData, groupName: e.target.value})} className="w-full bg-gray-800 border border-pink-700 focus:border-pink-400 rounded-2xl px-5 py-4 outline-none" placeholder="EmpowerHer Circle" />
            </div>
            <div>
              <label className="block text-pink-300 text-sm mb-2">Group Motto</label>
              <input type="text" value={formData.groupMotto} onChange={(e) => setFormData({...formData, groupMotto: e.target.value})} className="w-full bg-gray-800 border border-pink-700 focus:border-pink-400 rounded-2xl px-5 py-4 outline-none" placeholder="Together We Rise 💖" />
            </div>
          </div>

          <div>
            <label className="block text-pink-300 text-sm mb-2">Group Description</label>
            <textarea style={{height: "200px"}} value={formData.groupDesc} onChange={(e) => setFormData({...formData, groupDesc: e.target.value})} rows={4} className="w-full bg-gray-800 border border-pink-700 focus:border-pink-400 rounded-3xl px-5 py-4 outline-none resize-none" placeholder="Our journey, vision and values..." />
          </div>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            {['area', 'city', 'state', 'pincode'].map(field => (
              <div key={field}>
                <label className="block text-pink-300 text-sm mb-2 capitalize">{field}</label>
                <input type="text" value={formData[field]} onChange={(e) => setFormData({...formData, [field]: e.target.value})} className="w-full bg-gray-800 border border-pink-700 focus:border-pink-400 rounded-2xl px-5 py-4 outline-none" />
              </div>
            ))}
          </div>

          <div>
            <label className="block text-pink-300 text-sm mb-2">Full Address</label>
            <textarea style={{height: "100px"}} value={formData.address} onChange={(e) => setFormData({...formData, address: e.target.value})} rows={2} className="w-full bg-gray-800 border border-pink-700 focus:border-pink-400 rounded-3xl px-5 py-4 outline-none" />
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div>
              <label className="block text-pink-300 text-sm mb-2">Mobile</label>
              <input type="tel" value={formData.groupMobile} onChange={(e) => setFormData({...formData, groupMobile: e.target.value})} className="w-full bg-gray-800 border border-pink-700 focus:border-pink-400 rounded-2xl px-5 py-4 outline-none" />
            </div>
            <div>
              <label className="block text-pink-300 text-sm mb-2">WhatsApp</label>
              <input type="tel" value={formData.groupWhatsApp} onChange={(e) => setFormData({...formData, groupWhatsApp: e.target.value})} className="w-full bg-gray-800 border border-pink-700 focus:border-pink-400 rounded-2xl px-5 py-4 outline-none" />
            </div>
            <div>
              <label className="block text-pink-300 text-sm mb-2">Email</label>
              <input type="email" value={formData.groupEmail} onChange={(e) => setFormData({...formData, groupEmail: e.target.value})} className="w-full bg-gray-800 border border-pink-700 focus:border-pink-400 rounded-2xl px-5 py-4 outline-none" />
            </div>
          </div>

          <div>
            <label className="block text-pink-300 text-sm mb-2">Special Public Message</label>
            <textarea style={{height: "200px"}} value={formData.splPublicMessage} onChange={(e) => setFormData({...formData, splPublicMessage: e.target.value})} rows={3} className="w-full bg-gray-800 border border-pink-700 focus:border-pink-400 rounded-3xl px-5 py-4 outline-none" />
          </div>

          {message && (
            <div className="text-amber-400 text-sm px-1">{message}</div>
          )}

          <button onClick={onSubmit} disabled={!formData.groupName || submitting} className="w-fit px-2 py-2 bg-gradient-to-r from-pink-600 to-purple-600 hover:from-pink-500 hover:to-purple-500 rounded-3xl text-xl font-semibold disabled:opacity-50">
            {submitting ? 'Saving...' : (isEditing ? 'Save Changes ✨' : 'Create Our Group 🌷')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default SHGCreateEditModal;